import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach token from localStorage
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("ba_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Redirect owners with an expired subscription to the billing page (402 = Payment Required)
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 402 && !window.location.pathname.endsWith("/dashboard/billing")) {
      window.location.href = "/dashboard/billing";
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return err?.message || "Une erreur est survenue.";
}
